import React from 'react';

interface DataReviewBannerProps {
  locationName?: string;
  message?: string;
}

export const DataReviewBanner: React.FC<DataReviewBannerProps> = ({
  locationName,
  message = 'Data is currently under review'
}) => {
  return (
    <div style={{
      backgroundColor: '#FEF3C7',
      border: '1px solid #F59E0B',
      borderRadius: '4px',
      padding: '12px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}>
      <span style={{ fontSize: '16px' }}>⚠️</span>
      <div>
        <strong>Data Review Notice</strong>
        {locationName && <span>: {locationName}</span>}
        <div style={{ fontSize: '14px', marginTop: '4px' }}>{message}</div>
      </div>
    </div>
  );
};

export default DataReviewBanner;